var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.147 16.61H35.86a3.37 3.37 0 0 1 3.37 3.369V32.8a3.37 3.37 0 0 1-3.37 3.37H4.147a3.37 3.37 0 0 1-3.37-3.37V19.98a3.37 3.37 0 0 1 3.37-3.37z",
    fill: "#31B59F",
    stroke: "#35404A",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.23 29.485h-7.477a1.82 1.82 0 0 1-1.82-1.82v-2.551a1.82 1.82 0 0 1 1.82-1.82h7.478v6.191z",
    fill: "#31B59F",
    stroke: "#35404A",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.18 4.321-.592-1.83M9.671 4.254l.83-1.735M3.311 6.313l-1.688-.92",
    stroke: "#31B59F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.208 14.423-5.753-1.587-13.82-3.653-.943 3.506 10.047 1.679 10.469.055z",
    fill: "#31B59F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.052 11.006h.548c2.01 0 3.64 1.61 3.64 3.595v17.905c0 1.986-1.63 3.596-3.64 3.596H4.402c-2.01 0-3.64-1.61-3.64-3.596V14.15c0-1.736 1.425-3.144 3.183-3.144",
    stroke: "#35404A",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.927 13.335-.835-1.929-.304-.686-.74-1.671a3.145 3.145 0 0 0-2.287-1.866 2.493 2.493 0 0 0-1.45.174l-8.38 3.363M31.85 13.519l-3.776-1.123-4.368-1.185-10.64-2.862m-9.478 5.286.37-1.243.32-1.186.178-.652.43-1.587a2.826 2.826 0 0 1 1.788-1.972c.425-.144.882-.16 1.315-.045l1.124.27",
    stroke: "#35404A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v40H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.a5fdf44c340e7b83cf96650e20db811c.svg";
export { ForwardRef as ReactComponent };